import { Section, SectionHeading } from "@components/shared/Section";
import { cn } from "@/ui/utils/cn";

export type Step = { title: string; body: string };

/**
 * A numbered sequence. Numbers are justified here: the steps happen in
 * order. Lays out as a row on wide screens and a list on phones.
 */
export const Steps = ({
  title,
  steps,
  tone = "white",
  id,
}: {
  title: string;
  steps: Step[];
  tone?: "white" | "mist";
  id?: string;
}) => (
  <Section tone={tone} id={id}>
    <SectionHeading title={title} />
    <ol
      className={cn(
        "mt-12 grid gap-10 md:gap-8",
        steps.length === 4 ? "md:grid-cols-4" : "md:grid-cols-3",
      )}
    >
      {steps.map((step, index) => (
        <li key={step.title} className="relative flex gap-5 md:block">
          <span className="display grid h-11 w-11 shrink-0 place-items-center rounded-full bg-ink text-base text-white md:mb-5">
            {index + 1}
          </span>
          <div>
            <h3 className="text-h3 font-semibold">{step.title}</h3>
            <p className="mt-2 text-body text-slate-600">{step.body}</p>
          </div>
        </li>
      ))}
    </ol>
  </Section>
);
